/**
 * Ranked site table — sites sorted by average, color-coded badges.
 */

import type { SiteRanking } from '@/lib/dashboard/aggregations';

function scoreBadge(score: number | null) {
  if (score === null) return <span className="text-xs text-muted-foreground">—</span>;
  let bg = 'bg-rating-4/20 text-rating-4';
  if (score >= 5) bg = 'bg-rating-6/20 text-rating-6';
  else if (score >= 3) bg = 'bg-rating-4/20 text-yellow-700';
  else bg = 'bg-rating-1/20 text-rating-1';
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ${bg}`}>
      {score.toFixed(2)}
    </span>
  );
}

export function SiteRankingTable({ rankings }: { rankings: SiteRanking[] }) {
  if (rankings.length === 0) {
    return (
      <div className="rounded-xl border bg-card p-5 text-center text-sm text-muted-foreground">
        No sites to display.
      </div>
    );
  }

  return (
    <div className="rounded-xl border bg-card shadow-sm">
      <h3 className="px-5 pt-5 text-sm font-semibold text-muted-foreground uppercase tracking-wide">
        Site Rankings
      </h3>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b text-left text-xs text-muted-foreground">
              <th className="px-5 py-2 font-medium">#</th>
              <th className="px-5 py-2 font-medium">Site</th>
              <th className="px-5 py-2 font-medium text-center">Observations</th>
              <th className="px-5 py-2 font-medium text-center">Average</th>
            </tr>
          </thead>
          <tbody>
            {rankings.map((r, i) => (
              <tr key={r.siteName} className="border-b last:border-0 hover:bg-muted/50">
                <td className="px-5 py-3 font-medium text-muted-foreground">{i + 1}</td>
                <td className="px-5 py-3 font-medium">{r.siteName}</td>
                <td className="px-5 py-3 text-center">{r.observationCount}</td>
                <td className="px-5 py-3 text-center">{scoreBadge(r.average)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
